import { render } from "./LiuYaoRecordsPanel.vue?vue&type=template&id=fefc7cfe&scoped=true"
import script from "./LiuYaoRecordsPanel.vue?vue&type=script&lang=js"
export * from "./LiuYaoRecordsPanel.vue?vue&type=script&lang=js"

import "./LiuYaoRecordsPanel.vue?vue&type=style&index=0&id=fefc7cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fefc7cfe"]])

export default __exports__